export default __webpack_public_path__ + "static/media/SavingIcon.1f00485d.png";